import { $, $$ } from '@3pc/dom';
import { Player } from '@3pc/player-videojs';
import { ConsentOverlay, handleEmbed } from '@3pc/consent-overlay';

// for MP4 videos
const videos = $$('.video-player');
if (videos.length) {
  videos.forEach(video => {
    new Player({
      player: video,
    }).init();
  });
}

// for youtube, vimeo and iframe videos
const initEmbedVideos = () => {
  const overlays = $$('[data-consent-type]');
  overlays.length &&
    overlays.forEach(overlay => {
      const videoEmbed = $('.video-player__embed', overlay);
      let player = null;

      if (videoEmbed) player = new Player({ player: videoEmbed });

      new ConsentOverlay({
        container: overlay,
        nameSpace: 'drogenbeauftragter-video-embed',
        onActivation: (container, consentType) => {
          if (consentType === 'videoplayer') return player.init();
          if (consentType === 'embed') return handleEmbed(container, true);
        },
        onDeactivation: (container, consentType) => {
          if (consentType === 'videoplayer') return player.destroy();
          if (consentType === 'embed') return handleEmbed(container, false);
        },
      }).init();
    });
};
initEmbedVideos();
